// // frontend/src/pages/Dashboard.js
// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Button,
//   CircularProgress,
//   Paper,
//   Avatar,
//   Chip,
//   useTheme,
//   alpha,
//   Divider,
//   IconButton,
//   Fade,
//   Skeleton,
// } from "@mui/material";
// import { AuthContext } from "../contexts/AuthContext";

// import { useNavigate } from "react-router-dom";
// import { keyframes } from "@mui/system";
// import {
//   Announcement as AnnouncementIcon,
//   Work as WorkIcon,
//   Event as EventIcon,
//   Description as DescriptionIcon,
//   Chat as ChatIcon,
//   Assignment as AssignmentIcon,
//   Quiz as QuizIcon,
//   School as SchoolIcon,
//   CloudUpload as CloudUploadIcon,
//   Refresh as RefreshIcon,
//   Dashboard as DashboardIcon,
//   Person as PersonIcon,
//   Notifications as NotificationsIcon,
//   TrendingUp as TrendingUpIcon,
//   AutoAwesome as AutoAwesomeIcon,
//   Schedule as ScheduleIcon,
//   MenuBook as MenuBookIcon,
// } from "@mui/icons-material";

// // Keyframe animations
// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const pulse = keyframes`
//   0%, 100% { opacity: 0.6; }
//   50% { opacity: 1; }
// `;

// const float = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-10px); }
// `;

// const Dashboard = () => {
//   const [data, setData] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [userName, setUserName] = useState("");
//   const [submissions, setSubmissions] = useState([]);

//   const navigate = useNavigate();
//   const theme = useTheme();
//   // const [assignments, setAssignments] = useState([]);

//   const [subjects, setSubjects] = useState([]);
//   const [taskCount, settaskCounts] = useState(0);
//   const [completedCount, setcompletedCounts] = useState(0);

//   const [selectedSubject, setSelectedSubject] = useState("");
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   const { role, token } = useContext(AuthContext);

//   // const role = localStorage.getItem("role");

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const storedName = localStorage.getItem("username") || "User";
//     setUserName(storedName);

//     setLoading(true);
//     axios
//       .get(`${process.env.REACT_APP_API_URL}/api/protected`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setData(response.data.message);
//       })
//       .catch((error) => {
//         console.error("Error fetching protected data:", error);
//         setData("Welcome to your dashboard!");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []);

//   // Enhanced dashboard items with colors and categories
//   let dashboardItems = [
//     {
//       title: "Notices",
//       description: "View important announcements and updates",
//       path: "/notices",
//       icon: <AnnouncementIcon />,
//       color: "#FF6B6B",
//       category: "Communication",
//       gradient: "linear-gradient(135deg, #FF6B6B, #FF8E8E)",
//     },
//     {
//       title: "Internships",
//       description: "Discover career opportunities and internships",
//       path: "/internships",
//       icon: <WorkIcon />,
//       color: "#4ECDC4",
//       category: "Career",
//       gradient: "linear-gradient(135deg, #4ECDC4, #6EE6DD)",
//     },
//     {
//       title: "Calendar",
//       description: "Stay updated with events and schedules",
//       path: "/calendar",
//       icon: <EventIcon />,
//       color: "#45B7D1",
//       category: "Organization",
//       gradient: "linear-gradient(135deg, #45B7D1, #67C4E8)",
//     },
//     {
//       title: "Academic Resources",
//       description: "Access syllabus, papers and study materials",
//       path: "/documents",
//       icon: <DescriptionIcon />,
//       color: "#96CEB4",
//       category: "Academic",
//       gradient: "linear-gradient(135deg, #96CEB4, #B1D8C7)",
//     },
//     {
//       title: "AI Assistant",
//       description: "Get instant answers with our smart chatbot",
//       path: "/ai-chatbot",
//       icon: <AutoAwesomeIcon />,
//       color: "#FFEAA7",
//       category: "AI Tools",
//       gradient: "linear-gradient(135deg, #FFEAA7, #FDCB6E)",
//     },
//     {
//       title: "Live Chat",
//       description: "Connect with teachers and classmates",
//       path: "/chat",
//       icon: <ChatIcon />,
//       color: "#DDA0DD",
//       category: "Communication",
//       gradient: "linear-gradient(135deg, #DDA0DD, #E6B3E6)",
//     },
//     {
//       title: "Resource Hub",
//       description: "Upload and share learning resources",
//       path: "/resources",
//       icon: <CloudUploadIcon />,
//       color: "#74B9FF",
//       category: "Sharing",
//       gradient: "linear-gradient(135deg, #74B9FF, #9BC8FF)",
//     },
//   ];

  

//   // Add role-specific items
//   if (role === "student") {
//     dashboardItems = [
//       ...dashboardItems,
//       {
//         title: "My Assignments",
//         description: "View and manage your assignments",
//         path: "/assignments",
//         icon: <AssignmentIcon />,
//         color: "#81ECEC",
//         category: "Academic",
//         gradient: "linear-gradient(135deg, #81ECEC, #9AEAEA)",
//       },
//       {
//         title: "Submit Work",
//         description: "Submit your completed assignments",
//         path: "/student-assignment-submit",
//         icon: <MenuBookIcon />,
//         color: "#FD79A8",
//         category: "Academic",
//         gradient: "linear-gradient(135deg, #FD79A8, #FF9CBB)",
//       },
//       {
//         title: "My Progress",
//         description: "Track your academic performance",
//         path: "/mysubmissions",
//         icon: <TrendingUpIcon />,
//         color: "#FDCB6E",
//         category: "Progress",
//         gradient: "linear-gradient(135deg, #FDCB6E, #FFD93D)",
//       },
//       {
//         title: "Quiz Arena",
//         description: "Test your knowledge with interactive quizzes",
//         path: "/student-quiz-home",
//         icon: <QuizIcon />,
//         color: "#A29BFE",
//         category: "Assessment",
//         gradient: "linear-gradient(135deg, #A29BFE, #B8B0FF)",
//       },
//     ];
//   } else if (role === "teacher") {
//     dashboardItems = [
//       ...dashboardItems,
//       {
//         title: "All Assignments",
//         description: "Manage class assignments and deadlines",
//         path: "/assignments",
//         icon: <AssignmentIcon />,
//         color: "#55A3FF",
//         category: "Teaching",
//         gradient: "linear-gradient(135deg, #55A3FF, #78B4FF)",
//       },
//       {
//         title: "Quiz Creator",
//         description: "Design engaging quizzes for students",
//         path: "/teacher-quiz-create",
//         icon: <QuizIcon />,
//         color: "#FF7675",
//         category: "Assessment",
//         gradient: "linear-gradient(135deg, #FF7675, #FF9999)",
//       },
//       {
//         title: "Assignment Hub",
//         description: "Create and distribute new assignments",
//         path: "/teacher-assignment-create",
//         icon: <CloudUploadIcon />,
//         color: "#00B894",
//         category: "Teaching",
//         gradient: "linear-gradient(135deg, #00B894, #26D0B0)",
//       },
//       {
//         title: "Grading Center",
//         description: "Review and evaluate student work",
//         path: "/grade-submissions",
//         icon: <SchoolIcon />,
//         color: "#E17055",
//         category: "Assessment",
//         gradient: "linear-gradient(135deg, #E17055, #E88B73)",
//       },
//     ];
//   }

//   // Group items by category
//   const categorizedItems = dashboardItems.reduce((acc, item) => {
//     const category = item.category || "Other";
//     if (!acc[category]) acc[category] = [];
//     acc[category].push(item);
//     return acc;
//   }, {});

//   const quickStats = [
//     { label: "Active Tasks", value: `${taskCount}`, icon: <ScheduleIcon /> },
//     { label: "Completed", value: `${completedCount}`, icon: <TrendingUpIcon /> },
  
//   ];

//   // Fetch teacher/student subjects for dropdown
//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (!token) return;
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/api/users/me`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setSubjects(res.data.subjects || []); // fetch teacher/student subjects
//       } catch (err) {
//         console.error("Error fetching subjects:", err);
//       }
//     };
//     fetchSubjects();
//   }, [token]);

//   // Fetch assignments
//   // Helper functions for assignment status
//   const getAssignmentStatus = (dueDate) => {
//     const currentDate = new Date();
//     currentDate.setHours(0, 0, 0, 0);

//     const assignmentDueDate = new Date(dueDate);
//     assignmentDueDate.setHours(0, 0, 0, 0);

//     if (assignmentDueDate > currentDate) {
//       return "upcoming";
//     } else if (assignmentDueDate.getTime() === currentDate.getTime()) {
//       return "dueToday";
//     } else {
//       return "overdue";
//     }
//   };

//   const isAssignmentActive = (dueDate) => {
//     const currentDate = new Date();
//     currentDate.setHours(0, 0, 0, 0);

//     const assignmentDueDate = new Date(dueDate);
//     assignmentDueDate.setHours(0, 0, 0, 0);

//     // Assignment is active if due date is today or in the future
//     return assignmentDueDate >= currentDate;
//   };

//   const getAssignmentCounts = (assignments) => {
//     const counts = {
//       total: assignments.length,
//       active: 0,
//       upcoming: 0,
//       dueToday: 0,
//       overdue: 0,
//     };

//     assignments.forEach((assignment) => {
//       const status = getAssignmentStatus(assignment.dueDate);

//       switch (status) {
//         case "upcoming":
//           counts.upcoming++;
//           counts.active++;
//           break;
//         case "dueToday":
//           counts.dueToday++;
//           counts.active++;
//           break;
//         case "overdue":
//           counts.overdue++;
//           break;
//         default:
//           break;
//       }
//     });

//     return counts;
//   };

//   // Usage in your useEffect:
//   useEffect(() => {
//     const fetchAssignments = async () => {
//       setLoading(true);
//       try {
//         let url = `${process.env.REACT_APP_API_URL}/api/assignments`;
//         if (selectedSubject) {
//           url += `?subject=${encodeURIComponent(selectedSubject)}`;
//         }
//         const response = await axios.get(url, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         console.log(response.data);

//         // Get assignment counts
//         const assignmentCounts = getAssignmentCounts(response.data);

//         // Set active assignments count
//         settaskCounts(assignmentCounts.active);

//         console.log("Assignment Counts:", assignmentCounts);
//         /*
//       Output will be like:
//       {
//         total: 4,
//         active: 2,
//         upcoming: 1,
//         dueToday: 1,
//         overdue: 2
//       }
//       */
//       } catch (error) {
//         console.error("Error fetching assignments:", error);
//         setSnackbar({
//           open: true,
//           message: "Failed to load assignments.",
//           severity: "error",
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (token) fetchAssignments();
//   }, [token, selectedSubject]);

//   useEffect(() => {
//     const fetchSubmissions = async () => {
//       if (!token) return;
//       setLoading(true);
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/api/assignments/mysubmissions`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         setcompletedCounts(res.data.length)
//         setSubmissions(res.data);
//       } catch (error) {
//         console.error("Error fetching submissions:", error);
//         setSnackbar({
//           open: true,
//           message: "Failed to load submissions.",
//           severity: "error",
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSubmissions();
//   }, [token]);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Animated Background Elements */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: "10%",
//           left: "5%",
//           width: 100,
//           height: 100,
//           borderRadius: "50%",
//           background: alpha(theme.palette.common.white, 0.1),
//           animation: `${float} 4s ease-in-out infinite`,
//           zIndex: 0,
//         }}
//       />
//       <Box
//         sx={{
//           position: "absolute",
//           bottom: "20%",
//           right: "10%",
//           width: 150,
//           height: 150,
//           borderRadius: "50%",
//           background: alpha(theme.palette.common.white, 0.05),
//           animation: `${pulse} 3s ease-in-out infinite`,
//           zIndex: 0,
//         }}
//       />

//       <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1, py: 4 }}>
//         {/* Header Section */}
//         <Fade in={true} timeout={800}>
//           <Paper
//             elevation={0}
//             sx={{
//               background: alpha(theme.palette.common.white, 0.15),
//               backdropFilter: "blur(20px)",
//               borderRadius: 4,
//               p: 4,
//               mb: 4,
//               border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
//               animation: `${fadeInUp} 0.6s ease-out`,
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 flexWrap: "wrap",
//                 gap: 2,
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
//                 <Avatar
//                   sx={{
//                     width: 80,
//                     height: 80,
//                     background:
//                       "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
//                     fontSize: "2rem",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   <PersonIcon fontSize="large" />
//                 </Avatar>
//                 <Box>
//                   <Typography
//                     variant="h3"
//                     sx={{
//                       fontWeight: 900,
//                       color: "white",
//                       mb: 1,
//                       fontSize: { xs: "2rem", md: "3rem" },
//                     }}
//                   >
//                     {userName
//                       ? `Welcome back, ${userName}! 👋`
//                       : "Welcome! Please log in."}
//                   </Typography>

//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       mb: 2,
//                     }}
//                   >
//                     <Chip
//                       icon={<DashboardIcon />}
//                       label={`${role?.charAt(0).toUpperCase()}${role?.slice(
//                         1
//                       )} Dashboard`}
//                       sx={{
//                         background: alpha(theme.palette.common.white, 0.2),
//                         color: "white",
//                         fontWeight: "bold",
//                         backdropFilter: "blur(10px)",
//                       }}
//                     />
//                     <Chip
//                       icon={<NotificationsIcon />}
//                       label="New Updates"
//                       sx={{
//                         background: theme.palette.warning.main,
//                         color: "white",
//                         fontWeight: "bold",
//                       }}
//                     />
//                   </Box>
//                   {loading ? (
//                     <Skeleton
//                       variant="text"
//                       width={300}
//                       height={30}
//                       sx={{ bgcolor: alpha(theme.palette.common.white, 0.3) }}
//                     />
//                   ) : (
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         color: alpha(theme.palette.common.white, 0.9),
//                         fontWeight: 300,
//                       }}
//                     >
//                       {data || "Ready to continue your learning journey?"}
//                     </Typography>
//                   )}
//                 </Box>
//               </Box>
//               <IconButton
//                 onClick={() => window.location.reload()}
//                 sx={{
//                   background: alpha(theme.palette.common.white, 0.2),
//                   backdropFilter: "blur(10px)",
//                   color: "white",
//                   "&:hover": {
//                     background: alpha(theme.palette.common.white, 0.3),
//                     transform: "rotate(180deg)",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 <RefreshIcon />
//               </IconButton>
//             </Box>
//           </Paper>
//         </Fade>

//         {/* Quick Stats */}
//         <Fade in={true} timeout={1000}>
//           <Grid container spacing={3} sx={{ mb: 4 }}>
//             {quickStats.map((stat, index) => (
//               <Grid item xs={6} md={3} key={index}>
//                 <Card
//                   elevation={0}
//                   sx={{
//                     background: alpha(theme.palette.common.white, 0.9),
//                     backdropFilter: "blur(20px)",
//                     borderRadius: 3,
//                     p: 2,
//                     textAlign: "center",
//                     border: `1px solid ${alpha(
//                       theme.palette.common.white,
//                       0.3
//                     )}`,
//                     transition: "all 0.3s ease",
//                     animation: `${fadeInUp} 0.6s ease-out ${index * 0.1}s both`,
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: `0 10px 30px ${alpha(
//                         theme.palette.common.black,
//                         0.2
//                       )}`,
//                     },
//                   }}
//                 >
//                   <Box sx={{ color: theme.palette.primary.main, mb: 1 }}>
//                     {stat.icon}
//                   </Box>
//                   <Typography variant="h4" sx={{ fontWeight: "bold", mb: 0.5 }}>
//                     {stat.value}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     {stat.label}
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Fade>

//         {/* Dashboard Items by Category */}
//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
//             <CircularProgress size={60} sx={{ color: "white" }} />
//           </Box>
//         ) : (
//           Object.entries(categorizedItems).map(
//             ([category, items], categoryIndex) => (
//               <Fade
//                 in={true}
//                 timeout={1200 + categoryIndex * 200}
//                 key={category}
//               >
//                 <Box sx={{ mb: 6 }}>
//                   <Typography
//                     variant="h4"
//                     sx={{
//                       color: "white",
//                       fontWeight: "bold",
//                       mb: 3,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 2,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 6,
//                         height: 40,
//                         background:
//                           "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
//                         borderRadius: 3,
//                       }}
//                     />
//                     {category}
//                   </Typography>
//                   <Grid container spacing={3}>
//                     {items.map((item, index) => (
//                       <Grid item xs={12} sm={6} lg={4} key={index}>
//                         <Card
//                           elevation={0}
//                           sx={{
//                             height: "100%",
//                             cursor: "pointer",
//                             background: alpha(theme.palette.common.white, 0.95),
//                             backdropFilter: "blur(20px)",
//                             borderRadius: 4,
//                             border: `1px solid ${alpha(
//                               theme.palette.common.white,
//                               0.3
//                             )}`,
//                             transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                             animation: `${fadeInUp} 0.6s ease-out ${
//                               (categoryIndex * items.length + index) * 0.1
//                             }s both`,
//                             "&:hover": {
//                               transform: "translateY(-12px) scale(1.02)",
//                               boxShadow: `0 25px 50px ${alpha(
//                                 theme.palette.common.black,
//                                 0.25
//                               )}`,
//                               background: alpha(theme.palette.common.white, 1),
//                             },
//                           }}
//                           onClick={() => navigate(item.path)}
//                         >
//                           <CardContent
//                             sx={{
//                               p: 4,
//                               height: "100%",
//                               display: "flex",
//                               flexDirection: "column",
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "flex-start",
//                                 gap: 3,
//                                 mb: 2,
//                               }}
//                             >
//                               <Avatar
//                                 sx={{
//                                   width: 60,
//                                   height: 60,
//                                   background: item.gradient,
//                                   boxShadow: `0 8px 20px ${alpha(
//                                     item.color,
//                                     0.4
//                                   )}`,
//                                 }}
//                               >
//                                 {item.icon}
//                               </Avatar>
//                               <Box sx={{ flex: 1 }}>
//                                 <Typography
//                                   variant="h6"
//                                   sx={{
//                                     fontWeight: "bold",
//                                     mb: 1,
//                                     color: theme.palette.text.primary,
//                                   }}
//                                 >
//                                   {item.title}
//                                 </Typography>
//                                 <Chip
//                                   label={category}
//                                   size="small"
//                                   sx={{
//                                     backgroundColor: alpha(item.color, 0.1),
//                                     color: item.color,
//                                     fontWeight: "bold",
//                                     fontSize: "0.7rem",
//                                   }}
//                                 />
//                               </Box>
//                             </Box>
//                             <Typography
//                               variant="body2"
//                               sx={{
//                                 color: theme.palette.text.secondary,
//                                 lineHeight: 1.6,
//                                 flex: 1,
//                               }}
//                             >
//                               {item.description}
//                             </Typography>
//                             <Divider sx={{ my: 2, opacity: 0.3 }} />
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                                 color: item.color,
//                                 fontWeight: "bold",
//                                 fontSize: "0.9rem",
//                               }}
//                             >
//                               <span>Explore →</span>
//                               <Box
//                                 sx={{
//                                   width: 8,
//                                   height: 8,
//                                   borderRadius: "50%",
//                                   backgroundColor: item.color,
//                                   animation: `${pulse} 2s ease-in-out infinite`,
//                                 }}
//                               />
//                             </Box>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Fade>
//             )
//           )
//         )}

//         {/* Action Center */}
//         <Fade in={true} timeout={1600}>
//           <Paper
//             elevation={0}
//             sx={{
//               background: alpha(theme.palette.common.white, 0.1),
//               backdropFilter: "blur(20px)",
//               borderRadius: 4,
//               p: 4,
//               textAlign: "center",
//               border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
//               mt: 6,
//             }}
//           >
//             <Typography
//               variant="h5"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 mb: 2,
//               }}
//             >
//               Need Help Getting Started?
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{
//                 color: alpha(theme.palette.common.white, 0.8),
//                 mb: 3,
//                 maxWidth: 600,
//                 mx: "auto",
//               }}
//             >
//               Explore our platform features or get instant help from our AI
//               assistant
//             </Typography>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: 2,
//                 justifyContent: "center",
//                 flexWrap: "wrap",
//               }}
//             >
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<AutoAwesomeIcon />}
//                 onClick={() => navigate("/ai-chatbot")}
//                 sx={{
//                   px: 4,
//                   py: 1.5,
//                   borderRadius: 3,
//                   background:
//                     "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Ask AI Assistant
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 startIcon={<RefreshIcon />}
//                 onClick={() => window.location.reload()}
//                 sx={{
//                   px: 4,
//                   py: 1.5,
//                   borderRadius: 3,
//                   borderColor: alpha(theme.palette.common.white, 0.5),
//                   color: "white",
//                   fontWeight: "bold",
//                   "&:hover": {
//                     borderColor: "white",
//                     background: alpha(theme.palette.common.white, 0.1),
//                   },
//                 }}
//               >
//                 Refresh Dashboard
//               </Button>
//             </Box>
//           </Paper>
//         </Fade>
//       </Container>
//     </Box>
//   );
// };

// export default Dashboard;


// frontend/src/pages/Dashboard.js
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  CircularProgress,
  Paper,
  Avatar,
  Chip,
  useTheme,
  alpha,
  Divider,
  IconButton,
  Fade,
  Skeleton,
} from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";

import { useNavigate } from "react-router-dom";
import { keyframes } from "@mui/system";
import {
  Announcement as AnnouncementIcon,
  Work as WorkIcon,
  Event as EventIcon,
  Description as DescriptionIcon,
  Chat as ChatIcon,
  Assignment as AssignmentIcon,
  Quiz as QuizIcon,
  School as SchoolIcon,
  CloudUpload as CloudUploadIcon,
  Refresh as RefreshIcon,
  Dashboard as DashboardIcon,
  Person as PersonIcon,
  Notifications as NotificationsIcon,
  TrendingUp as TrendingUpIcon,
  AutoAwesome as AutoAwesomeIcon,
  Schedule as ScheduleIcon,
  MenuBook as MenuBookIcon,
} from "@mui/icons-material";

// Keyframe animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const Dashboard = () => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [submissions, setSubmissions] = useState([]);

  const navigate = useNavigate();
  const theme = useTheme();
  // const [assignments, setAssignments] = useState([]);

  const [subjects, setSubjects] = useState([]);
  const [taskCount, settaskCounts] = useState(0);
  const [completedCount, setcompletedCounts] = useState(0);

  const [selectedSubject, setSelectedSubject] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const { role, token } = useContext(AuthContext);

  // const role = localStorage.getItem("role");

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedName = localStorage.getItem("username") || "User";
    setUserName(storedName);

    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/protected`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setData(response.data.message);
      })
      .catch((error) => {
        console.error("Error fetching protected data:", error);
        setData("Welcome to your dashboard!");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Enhanced dashboard items with colors and categories
  let dashboardItems = [
    {
      title: "Notices",
      description: "View important announcements and updates",
      path: "/notices",
      icon: <AnnouncementIcon />,
      color: "#FF6B6B",
      category: "Communication",
      gradient: "linear-gradient(135deg, #FF6B6B, #FF8E8E)",
    },
    {
      title: "Internships",
      description: "Discover career opportunities and internships",
      path: "/internships",
      icon: <WorkIcon />,
      color: "#4ECDC4",
      category: "Career",
      gradient: "linear-gradient(135deg, #4ECDC4, #6EE6DD)",
    },
    {
      title: "Calendar",
      description: "Stay updated with events and schedules",
      path: "/calendar",
      icon: <EventIcon />,
      color: "#45B7D1",
      category: "Organization",
      gradient: "linear-gradient(135deg, #45B7D1, #67C4E8)",
    },
    {
      title: "Academic Resources",
      description: "Access syllabus, papers and study materials",
      path: "/documents",
      icon: <DescriptionIcon />,
      color: "#96CEB4",
      category: "Academic",
      gradient: "linear-gradient(135deg, #96CEB4, #B1D8C7)",
    },
    {
      title: "AI Assistant",
      description: "Get instant answers with our smart chatbot",
      path: "/ai-chatbot",
      icon: <AutoAwesomeIcon />,
      color: "#FFEAA7",
      category: "AI Tools",
      gradient: "linear-gradient(135deg, #FFEAA7, #FDCB6E)",
    },
    {
      title: "Live Chat",
      description: "Connect with teachers and classmates",
      path: "/chat",
      icon: <ChatIcon />,
      color: "#DDA0DD",
      category: "Communication",
      gradient: "linear-gradient(135deg, #DDA0DD, #E6B3E6)",
    },
    {
      title: "Resource Hub",
      description: "Upload and share learning resources",
      path: "/resources",
      icon: <CloudUploadIcon />,
      color: "#74B9FF",
      category: "Sharing",
      gradient: "linear-gradient(135deg, #74B9FF, #9BC8FF)",
    },
  ];

  

  // Add role-specific items
  if (role === "student") {
    dashboardItems = [
      ...dashboardItems,
      {
        title: "My Assignments",
        description: "View and manage your assignments",
        path: "/assignments",
        icon: <AssignmentIcon />,
        color: "#81ECEC",
        category: "Academic",
        gradient: "linear-gradient(135deg, #81ECEC, #9AEAEA)",
      },
      {
        title: "Submit Work",
        description: "Submit your completed assignments",
        path: "/student-assignment-submit",
        icon: <MenuBookIcon />,
        color: "#FD79A8",
        category: "Academic",
        gradient: "linear-gradient(135deg, #FD79A8, #FF9CBB)",
      },
      {
        title: "My Progress",
        description: "Track your academic performance",
        path: "/mysubmissions",
        icon: <TrendingUpIcon />,
        color: "#FDCB6E",
        category: "Progress",
        gradient: "linear-gradient(135deg, #FDCB6E, #FFD93D)",
      },
      {
        title: "Quiz Arena",
        description: "Test your knowledge with interactive quizzes",
        path: "/student-quiz-home",
        icon: <QuizIcon />,
        color: "#A29BFE",
        category: "Assessment",
        gradient: "linear-gradient(135deg, #A29BFE, #B8B0FF)",
      },
    ];
  } else if (role === "teacher") {
    dashboardItems = [
      ...dashboardItems,
      {
        title: "All Assignments",
        description: "Manage class assignments and deadlines",
        path: "/assignments",
        icon: <AssignmentIcon />,
        color: "#55A3FF",
        category: "Teaching",
        gradient: "linear-gradient(135deg, #55A3FF, #78B4FF)",
      },
      {
        title: "Quiz Creator",
        description: "Design engaging quizzes for students",
        path: "/teacher-quiz-create",
        icon: <QuizIcon />,
        color: "#FF7675",
        category: "Assessment",
        gradient: "linear-gradient(135deg, #FF7675, #FF9999)",
      },
      {
        title: "Assignment Hub",
        description: "Create and distribute new assignments",
        path: "/teacher-assignment-create",
        icon: <CloudUploadIcon />,
        color: "#00B894",
        category: "Teaching",
        gradient: "linear-gradient(135deg, #00B894, #26D0B0)",
      },
      {
        title: "Grading Center",
        description: "Review and evaluate student work",
        path: "/grade-submissions",
        icon: <SchoolIcon />,
        color: "#E17055",
        category: "Assessment",
        gradient: "linear-gradient(135deg, #E17055, #E88B73)",
      },
    ];
  }

  // Group items by category
  const categorizedItems = dashboardItems.reduce((acc, item) => {
    const category = item.category || "Other";
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});

  // Only show quick stats for students
  const quickStats = role === "student" ? [
    { label: "Active Tasks", value: `${taskCount}`, icon: <ScheduleIcon /> },
    { label: "Completed", value: `${completedCount}`, icon: <TrendingUpIcon /> },
  ] : [];

  // Fetch teacher/student subjects for dropdown
  useEffect(() => {
    const fetchSubjects = async () => {
      if (!token) return;
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/me`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSubjects(res.data.subjects || []); // fetch teacher/student subjects
      } catch (err) {
        console.error("Error fetching subjects:", err);
      }
    };
    fetchSubjects();
  }, [token]);

  // Fetch assignments
  // Helper functions for assignment status
  const getAssignmentStatus = (dueDate) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const assignmentDueDate = new Date(dueDate);
    assignmentDueDate.setHours(0, 0, 0, 0);

    if (assignmentDueDate > currentDate) {
      return "upcoming";
    } else if (assignmentDueDate.getTime() === currentDate.getTime()) {
      return "dueToday";
    } else {
      return "overdue";
    }
  };

  const isAssignmentActive = (dueDate) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const assignmentDueDate = new Date(dueDate);
    assignmentDueDate.setHours(0, 0, 0, 0);

    // Assignment is active if due date is today or in the future
    return assignmentDueDate >= currentDate;
  };

  const getAssignmentCounts = (assignments) => {
    const counts = {
      total: assignments.length,
      active: 0,
      upcoming: 0,
      dueToday: 0,
      overdue: 0,
    };

    assignments.forEach((assignment) => {
      const status = getAssignmentStatus(assignment.dueDate);

      switch (status) {
        case "upcoming":
          counts.upcoming++;
          counts.active++;
          break;
        case "dueToday":
          counts.dueToday++;
          counts.active++;
          break;
        case "overdue":
          counts.overdue++;
          break;
        default:
          break;
      }
    });

    return counts;
  };

  // Usage in your useEffect:
  useEffect(() => {
    const fetchAssignments = async () => {
      // Only fetch assignments for students
      if (role !== "student") return;
      
      setLoading(true);
      try {
        let url = `${process.env.REACT_APP_API_URL}/api/assignments`;
        if (selectedSubject) {
          url += `?subject=${encodeURIComponent(selectedSubject)}`;
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log(response.data);

        // Get assignment counts
        const assignmentCounts = getAssignmentCounts(response.data);

        // Set active assignments count
        settaskCounts(assignmentCounts.active);

        console.log("Assignment Counts:", assignmentCounts);
        /*
      Output will be like:
      {
        total: 4,
        active: 2,
        upcoming: 1,
        dueToday: 1,
        overdue: 2
      }
      */
      } catch (error) {
        console.error("Error fetching assignments:", error);
        setSnackbar({
          open: true,
          message: "Failed to load assignments.",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchAssignments();
  }, [token, selectedSubject, role]);

  useEffect(() => {
    const fetchSubmissions = async () => {
      // Only fetch submissions for students
      if (!token || role !== "student") return;
      
      setLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/assignments/mysubmissions`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setcompletedCounts(res.data.length)
        setSubmissions(res.data);
      } catch (error) {
        console.error("Error fetching submissions:", error);
        setSnackbar({
          open: true,
          message: "Failed to load submissions.",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchSubmissions();
  }, [token, role]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated Background Elements */}
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          left: "5%",
          width: 100,
          height: 100,
          borderRadius: "50%",
          background: alpha(theme.palette.common.white, 0.1),
          animation: `${float} 4s ease-in-out infinite`,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "20%",
          right: "10%",
          width: 150,
          height: 150,
          borderRadius: "50%",
          background: alpha(theme.palette.common.white, 0.05),
          animation: `${pulse} 3s ease-in-out infinite`,
          zIndex: 0,
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1, py: 4 }}>
        {/* Header Section */}
        <Fade in={true} timeout={800}>
          <Paper
            elevation={0}
            sx={{
              background: alpha(theme.palette.common.white, 0.15),
              backdropFilter: "blur(20px)",
              borderRadius: 4,
              p: 4,
              mb: 4,
              border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
              animation: `${fadeInUp} 0.6s ease-out`,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    background:
                      "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
                    fontSize: "2rem",
                    fontWeight: "bold",
                  }}
                >
                  <PersonIcon fontSize="large" />
                </Avatar>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 900,
                      color: "white",
                      mb: 1,
                      fontSize: { xs: "2rem", md: "3rem" },
                    }}
                  >
                    {userName
                      ? `Welcome back, ${userName}! 👋`
                      : "Welcome! Please log in."}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <Chip
                      icon={<DashboardIcon />}
                      label={`${role?.charAt(0).toUpperCase()}${role?.slice(
                        1
                      )} Dashboard`}
                      sx={{
                        background: alpha(theme.palette.common.white, 0.2),
                        color: "white",
                        fontWeight: "bold",
                        backdropFilter: "blur(10px)",
                      }}
                    />
                    {/* <Chip
                      icon={<NotificationsIcon />}
                      label="New Updates"
                      sx={{
                        background: theme.palette.warning.main,
                        color: "white",
                        fontWeight: "bold",
                      }}
                    /> */}
                  </Box>
                  {loading ? (
                    <Skeleton
                      variant="text"
                      width={300}
                      height={30}
                      sx={{ bgcolor: alpha(theme.palette.common.white, 0.3) }}
                    />
                  ) : (
                    <Typography
                      variant="h6"
                      sx={{
                        color: alpha(theme.palette.common.white, 0.9),
                        fontWeight: 300,
                      }}
                    >
                      {data || "Ready to continue your learning journey?"}
                    </Typography>
                  )}
                </Box>
              </Box>
              <IconButton
                onClick={() => window.location.reload()}
                sx={{
                  background: alpha(theme.palette.common.white, 0.2),
                  backdropFilter: "blur(10px)",
                  color: "white",
                  "&:hover": {
                    background: alpha(theme.palette.common.white, 0.3),
                    transform: "rotate(180deg)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <RefreshIcon />
              </IconButton>
            </Box>
          </Paper>
        </Fade>

        {/* Quick Stats - Only for Students */}
        {role === "student" && quickStats.length > 0 && (
          <Fade in={true} timeout={1000}>
            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  mb: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 40,
                    background:
                      "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
                    borderRadius: 3,
                  }}
                />
                Tasks
              </Typography>
              <Grid container spacing={3}>
                {quickStats.map((stat, index) => (
                  <Grid item xs={6} md={3} key={index}>
                    <Card
                      elevation={0}
                      sx={{
                        background: alpha(theme.palette.common.white, 0.9),
                        backdropFilter: "blur(20px)",
                        borderRadius: 3,
                        p: 2,
                        textAlign: "center",
                        border: `1px solid ${alpha(
                          theme.palette.common.white,
                          0.3
                        )}`,
                        transition: "all 0.3s ease",
                        animation: `${fadeInUp} 0.6s ease-out ${index * 0.1}s both`,
                        "&:hover": {
                          transform: "translateY(-5px)",
                          boxShadow: `0 10px 30px ${alpha(
                            theme.palette.common.black,
                            0.2
                          )}`,
                        },
                      }}
                    >
                      <Box sx={{ color: theme.palette.primary.main, mb: 1 }}>
                        {stat.icon}
                      </Box>
                      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 0.5 }}>
                        {stat.value}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {stat.label}
                      </Typography>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Fade>
        )}

        {/* Dashboard Items by Category */}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
            <CircularProgress size={60} sx={{ color: "white" }} />
          </Box>
        ) : (
          Object.entries(categorizedItems).map(
            ([category, items], categoryIndex) => (
              <Fade
                in={true}
                timeout={1200 + categoryIndex * 200}
                key={category}
              >
                <Box sx={{ mb: 6 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "white",
                      fontWeight: "bold",
                      mb: 3,
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: 6,
                        height: 40,
                        background:
                          "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
                        borderRadius: 3,
                      }}
                    />
                    {category}
                  </Typography>
                  <Grid container spacing={3}>
                    {items.map((item, index) => (
                      <Grid item xs={12} sm={6} lg={4} key={index}>
                        <Card
                          elevation={0}
                          sx={{
                            height: "100%",
                            cursor: "pointer",
                            background: alpha(theme.palette.common.white, 0.95),
                            backdropFilter: "blur(20px)",
                            borderRadius: 4,
                            border: `1px solid ${alpha(
                              theme.palette.common.white,
                              0.3
                            )}`,
                            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                            animation: `${fadeInUp} 0.6s ease-out ${
                              (categoryIndex * items.length + index) * 0.1
                            }s both`,
                            "&:hover": {
                              transform: "translateY(-12px) scale(1.02)",
                              boxShadow: `0 25px 50px ${alpha(
                                theme.palette.common.black,
                                0.25
                              )}`,
                              background: alpha(theme.palette.common.white, 1),
                            },
                          }}
                          onClick={() => navigate(item.path)}
                        >
                          <CardContent
                            sx={{
                              p: 4,
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 3,
                                mb: 2,
                              }}
                            >
                              <Avatar
                                sx={{
                                  width: 60,
                                  height: 60,
                                  background: item.gradient,
                                  boxShadow: `0 8px 20px ${alpha(
                                    item.color,
                                    0.4
                                  )}`,
                                }}
                              >
                                {item.icon}
                              </Avatar>
                              <Box sx={{ flex: 1 }}>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: "bold",
                                    mb: 1,
                                    color: theme.palette.text.primary,
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Chip
                                  label={category}
                                  size="small"
                                  sx={{
                                    backgroundColor: alpha(item.color, 0.1),
                                    color: item.color,
                                    fontWeight: "bold",
                                    fontSize: "0.7rem",
                                  }}
                                />
                              </Box>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                color: theme.palette.text.secondary,
                                lineHeight: 1.6,
                                flex: 1,
                              }}
                            >
                              {item.description}
                            </Typography>
                            <Divider sx={{ my: 2, opacity: 0.3 }} />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                color: item.color,
                                fontWeight: "bold",
                                fontSize: "0.9rem",
                              }}
                            >
                              <span>Explore →</span>
                              <Box
                                sx={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "50%",
                                  backgroundColor: item.color,
                                  animation: `${pulse} 2s ease-in-out infinite`,
                                }}
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Fade>
            )
          )
        )}

        {/* Action Center */}
        <Fade in={true} timeout={1600}>
          <Paper
            elevation={0}
            sx={{
              background: alpha(theme.palette.common.white, 0.1),
              backdropFilter: "blur(20px)",
              borderRadius: 4,
              p: 4,
              textAlign: "center",
              border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
              mt: 6,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "white",
                fontWeight: "bold",
                mb: 2,
              }}
            >
              Need Help Getting Started?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: alpha(theme.palette.common.white, 0.8),
                mb: 3,
                maxWidth: 600,
                mx: "auto",
              }}
            >
              Explore our platform features or get instant help from our AI
              assistant
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Button
                variant="contained"
                size="large"
                startIcon={<AutoAwesomeIcon />}
                onClick={() => navigate("/ai-chatbot")}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  background:
                    "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
                  fontWeight: "bold",
                }}
              >
                Ask AI Assistant
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<RefreshIcon />}
                onClick={() => window.location.reload()}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  borderColor: alpha(theme.palette.common.white, 0.5),
                  color: "white",
                  fontWeight: "bold",
                  "&:hover": {
                    borderColor: "white",
                    background: alpha(theme.palette.common.white, 0.1),
                  },
                }}
              >
                Refresh Dashboard
              </Button>
            </Box>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default Dashboard;